var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"col-xs-4\">\n                    <div class=\"leaflet-popup-retention-value\">\n                        "
    + alias1(__default(require("./numeral.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"percent") : depth0),{"name":"numeral","hash":{"format":"0,0%"},"data":data,"loc":{"start":{"line":14,"column":24},"end":{"line":14,"column":57}}}))
    + "\n                    </div>\n                    <div class=\"leaflet-popup-retention-title\">\n                        "
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0))
    + "\n                    </div>\n                </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"leaflet-popup-body\">\n    <div class=\"leaflet-popup-header\">\n        "
    + container.escapeExpression(__default(require("./i18n.js")).call(alias1,"Common.Clients",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":33}}}))
    + "\n    </div>\n    <div class=\"row leaflet-popup-retention\" style=\"margin-bottom: -12px\">\n        <div>\n            <div id=\"map-popup-chart\" class=\"col-xs-12\" style=\"height: 140px\">\n            </div>\n        </div>\n        <div>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"clients") : depth0),{"name":"each","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":12},"end":{"line":20,"column":21}}})) != null ? stack1 : "")
    + "        </div>\n    </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-clients-cluster-popup.hbs
// module id = IqAc
// module chunks = 1